export default {
    type: 'vacancies',
    name: 'Vacancies',
    osOnly: true,
    components: {
        root: {
            name: 'ModuleVacancies',
            loader: () => import('./ModuleVacancies')
        }
    }
};
